import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { ControlContainer, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConcessaoVeiculoDTO } from 'app/model/dtos/mob/concessao-veiculo.dto';
import { ConcessaoVeiculoService } from 'app/services/mob/concessao-veiculo.service';
import { ConcessaoVeiculoSearch } from 'app/services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-veiculo-situacao.enum';
import { DialogFactory } from 'sol-tools-ts/dist';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'autocomplete-placa-mototaxi',
  templateUrl: './autocomplete-placa-mototaxi.component.html',
  styleUrls: ['./autocomplete-placa-mototaxi.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompletePlacaMototaxiComponent implements OnInit {
  
  concessaoVeiculos: ConcessaoVeiculoDTO[];
  formGroup: FormGroup;
  cdPessoa: number;

  constructor(
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory,
    private _concessaoVeiculoService: ConcessaoVeiculoService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('cdPessoa').valueChanges.subscribe(_ => {
      this.cdPessoa = this.formGroup.get('cdPessoa').value;
      this.load();
    })
  }

  async load(){
    try{
      this.concessaoVeiculos = await this._concessaoVeiculoService.findVeiculos(new ConcessaoVeiculoSearch({
        cdConcessionario: this.cdPessoa, 
        tpConcessao: ConcessaoTipo.MOTO_TAXI, 
        stConcessaoVeiculo: ConcessaoVeiculoSituacao.VINCULADO
      }));
      this.setPlaca();
    }catch(error){
      this._dialogFactory.snack(error.message, 'OK', DialogFactory.SNACK_ERROR);
    }
  }

  setPlaca() {
    if(this.concessaoVeiculos.length == 1) {
      this.formGroup.get('cdVeiculo').setValue(this.concessaoVeiculos[0].cdVeiculo);
    }
  }
  
  selecionarVeiculo(cdVeiculo:number){
    this.formGroup.get('cdVeiculo').setValue(cdVeiculo);
  }
}
